import {useEffect,useState} from "react";
import {X} from "lucide-react";
import styles from "./PwaUpdateNotice.module.css";

/** Keep the waiting worker waiting. An update must not reload another open
 * editor, drop an IME composition, or replace an in-memory form/chat draft. */
export function PwaUpdateNotice(){
  const [available,setAvailable]=useState(false),[dismissed,setDismissed]=useState(false);
  useEffect(()=>{
    if(!("serviceWorker" in navigator))return;
    let alive=true,cleanup=()=>{};
    void navigator.serviceWorker.ready.then(registration=>{
      if(!alive)return;
      const watched=new Map<ServiceWorker,()=>void>();
      const notify=()=>{if(alive&&navigator.serviceWorker.controller){setAvailable(true);setDismissed(false);}};
      const watch=()=>{
        const worker=registration.installing;
        if(!worker||watched.has(worker))return;
        const changed=()=>{if(worker.state==="installed")notify();};
        worker.addEventListener("statechange",changed);watched.set(worker,changed);changed();
      };
      if(registration.waiting)notify();
      registration.addEventListener("updatefound",watch);watch();
      let lastCheck=Date.now();
      const check=()=>{
        if(document.visibilityState==="hidden"||Date.now()-lastCheck<5*60_000)return;
        lastCheck=Date.now();void registration.update().catch(()=>undefined);
      };
      const timer=setInterval(check,5*60_000);
      window.addEventListener("focus",check);document.addEventListener("visibilitychange",check);
      cleanup=()=>{
        clearInterval(timer);registration.removeEventListener("updatefound",watch);
        for(const [worker,changed] of watched)worker.removeEventListener("statechange",changed);
        window.removeEventListener("focus",check);document.removeEventListener("visibilitychange",check);
      };
    }).catch(()=>undefined);
    return()=>{alive=false;cleanup();};
  },[]);
  if(!available||dismissed)return null;
  return <aside className={styles.notice} aria-label="网站更新" role="status">
    <div><strong>新版本已准备好</strong><p>可以继续写作。保存好当前内容，关闭此网站的所有页面后重新打开，即可使用新版。</p></div>
    <button type="button" aria-label="稍后更新" title="稍后更新" onClick={()=>setDismissed(true)}><X size={16} aria-hidden="true"/></button>
  </aside>;
}
